import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { SetPreorderPublishedRequest } from './set-preorder-published.request';

@Injectable({ providedIn: 'root' })
export class SetPreorderPublishedUseCase extends UseCase<SetPreorderPublishedRequest, Observable<HttpResponse<unknown>>> {

    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);
    private _setPublishedUrl = '/admin/setpublished';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: SetPreorderPublishedRequest): Observable<HttpResponse<unknown>> | void {
        return this._apiRequestService.sendRequest<SetPreorderPublishedRequest, HttpResponse<unknown>>(
            this._storeBaseUrl,
            request,
            true,
            this._setPublishedUrl,
            true
        );
    }
}
